import { Component, OnInit } from '@angular/core';
import { Profession } from '../../models/profession.model';
import { ProfessionMockService } from '../../services/profession-mock.service';

@Component({
  selector: 'bwc-saved-professions',
  templateUrl: './saved-professions.component.html',
  styleUrls: ['./saved-professions.component.scss'],
})
export class SavedProfessionsComponent implements OnInit {
  savedProfessions: Profession[] = [];

  constructor(private professionService: ProfessionMockService) {}

  ngOnInit(): void {
    this.loadSaved();
  }

  unlike(profession: Profession): void {
    this.professionService.toggleSaveProfession(profession);
    this.loadSaved();
  }

  private loadSaved(): void {
    this.professionService.getSavedProfessions().subscribe(p => (this.savedProfessions = p));
  }
}
